import moment from "moment";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getDisputes } from "../../actions/disputes";
import { amountFormat } from "../../utils";
import BaseCurrency from "../Common/BaseCurrency";
import TableWrap from "../Common/Table/Table";
import PageHeader from "../PageHeader";
import DisputeModal from "./DisputeModal";

const Disputes = () => {
  const [page, setPage] = React.useState(1);
  const [showDispute, setShowDispute] = React.useState(false);
  const [filters, setFilters] = React.useState({});

  const dispatch = useDispatch();
  const disputesResponse = useSelector(
    (state) => state.disputes.all?.data || []
  );
  const disputesLoading = useSelector((state) => state.disputes.all?.loading);

  const columns = [
    {
      title: "Dispute ID",
      dataIndex: "dispute_id",
      key: "dispute_id",
      render: (text, record) => <div className={`render_common_style status_${record?.status}`}>{text}</div>
    },
    {
      title: "Transaction ID",
      dataIndex: "transaction_id",
      key: "transaction_id",
    },
    {
      // title: "Card Number",
      title: "Card Reference Number",
      dataIndex: "account",
      key: "account",
    },
    {
      title: "Amount",
      dataIndex: "amount",
      key: "amount",
      render: (text) => (
        <div>
          {" "}
          <BaseCurrency /> {amountFormat(text)}
        </div>
      ),
    },
    {
      title: "Reason",
      dataIndex: "reason",
      key: "reason",
      render: (text) => (
        <div
          style={{
            textTransform: "capitalize",
          }}
        >
          {text}
        </div>
      ),
    },
    // {
    //   title: "Customer",
    //   dataIndex: "remitter_name",
    //   key: "remitter_name",
    // },
    {
      title: "Disputed On",
      dataIndex: "created_at",
      key: "created_at",
      render: (text) => moment(text).format("DD-MM-YYYY"),
    },
    // {
    //   title: "Respond By",
    //   dataIndex: "responded_by",
    //   key: "responded_by",
    //   render: (text) => text ?? "-",
    // },

    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      // render: (status) => {
      //   return <span className={`status status_${status}`}>{status}</span>;
      // },
      render: (text) => <div className={`status status_${text}`}>{text.replace(/_/g, ' ')}</div>,
    },
  ];

  useEffect(() => {
    dispatch(
      getDisputes({
        page: 1,
        source: "admin",
      })
    );
  }, []);

  const handleSearch = (value) => {
    dispatch(
      getDisputes({ ...filters, page: 1, search: value, source: "admin" })
    );
    setFilters({
      ...filters,
      search: value,
    });
    setPage(1);
  };

  return (
    <div>
      <DisputeModal
        isModalVisible={showDispute}
        handleCancel={() => {
          setShowDispute(false);
        }}
      />
      <div className="heading-div">
        <PageHeader
          title={`Disputes`}
          navigation={{
            Home: "/dashboard/",
            Disputes: "/disputes/",
          }}
        />
      </div>
      <TableWrap
        rowKey="id"
        className="tableStyled"
        columns={columns}
        data={
          Array.isArray(disputesResponse?.response?.disputes)
            ? disputesResponse?.response?.disputes
            : []
        }
        placeholder={"Search by Transaction ID, Card No"}
        pagination={{
          total: disputesResponse?.total_records || 0,
          current: page,

          onChange: (pagee) => {
            dispatch(
              getDisputes({
                page: pagee,
                source: "admin",
              })
            );
            setPage(pagee);
          },
        }}
        dotMenu={["amount", "disputed_on"]}
        handleSort={(key) => {
          dispatch(
            getDisputes({ ...filters, page: 1, sort_key: key, source: "admin" })
          );
          setFilters({
            ...filters,
            sort_key: key,
          });
          setPage(1);
        }}
        isTopFilter={true}
        filter={false}
        filterMenu={true}
        sort={true}
        handleRowClick={(_e, record) => {
          setShowDispute(record);
        }}
        handleSearch={handleSearch}
        // scroll={{ x: 1000 }}
        scroll={{ x: "max-content" }}
        loading={disputesLoading}
      />
    </div>
  );
};

export default Disputes;
